export enum MetricName {
  SESSION_RECORDING_RATE = 'session_recording_rate',
  SESSION_RECORDING_WITH_ERROR_RATE = 'session_recording_with_error_rate',
  ISSUE_RATE = 'issue_rate',
  END_USER_ACTIVITY = 'end_user_activity',
}
